import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import cn from 'classnames';

import EditKpisPage from 'components/hr//EditKpisPage.component';
import HumanResourcesMenu from 'components/hr/HumanResourcesMenu.component';
import StaffCommissions from 'components/hr/StaffCommissions.component';
import TimeOffSettingsLayout from 'components/hr/TimeOffSettingsLayout.component';
import TimeOffSplashPage from 'components/hr/timeOffSplash/TimeOffSplashPage.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonBilling, selectCurrentSalonPricingPlan } from 'selectors/currentSalon.selectors';

import TopNav from 'common/TopNav.component';
import NotFoundComponent from 'lib/NotFoundComponent';

import CN from './HumanResources.module.scss';

const HumanResources = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="HumanResources"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <TopNav title={t('humanResources.headerMenu.title')}>
        <SidebarMenu />
      </TopNav>

      <HumanResourcesMenu />

      <Switch>
        <Route exact path={LINK.hrSplash} component={TimeOffSplashPage} />
        <Route exact path={LINK.hrEditKpi} component={EditKpisPage} />

        <Route exact path={LINK.hrCommissions} component={StaffCommissions} />
        <Route exact path={LINK.hrTimeoff} component={TimeOffSettingsLayout} />

        {/* NOTE: Not Found route, MUST be the last child of Switch,
         * also deleting it will cause an empty page when trying
         * to access a route inside of /hr that does not exist (i.e. /hr/blablabla).
         * TODO: Fix the 404 handling for all routes at App.jsx
         */}

        <Route component={NotFoundComponent} />
      </Switch>
    </div>
  );
};

const mapStateToProps = (state) => ({
  hasBilling: selectCurrentSalonBilling(state),
  pricingPlan: selectCurrentSalonPricingPlan(state),
});

const HumanResourcesHoc = connect(mapStateToProps)(HumanResources);

export default HumanResourcesHoc;
